module.exports = __webpack_public_path__ + "static/media/roberto-martinez-WBgPMst9toY-unsplash.1973caeb.jpg";